import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		teamsFilterDep: {
			[theme.breakpoints.down('sm')]: {
				'& div': { maxWidth: '130px', maxHeight: '35px' },
			},
		},
		titleArrowBack: {
			alignSelf: 'center',
			cursor: 'pointer',
		},
		backButtonContainer: {
			marginRight: theme.spacing(2),
		},
		backButton: {
			padding: '6px 0px',
			minWidth: '40px',
			lineHeight: 1,
		},
		title: {
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			'& div:nth-child(2)': {
				margin: '0px 5px',
			},
			'& #teams': {
				fontWeight: 'bold',
			},
		},
		departmentCard: {
			padding: '10px',
			[theme.breakpoints.only('xs')]: {
				margin: '10px 0'
			}
		},
		filterSwipeContainer: {
			position: 'absolute',
			top: '20px',
			right: '40px',
			width: 'auto',
			maxWidth: '350px',
			paddingLeft: '20px',
		}
	})
